export default "__VITE_ASSET__538b4290__"